import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-656d904a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative py-2 font-bold text-center status"
}

import { useSystemStore } from '@/store/system';
import { inject, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const systemStore = useSystemStore();

const dismissed = ref(false);

const $socket = inject('$socket') as any;
$socket.on('status', (data: string) => {
  systemStore.status = data;
  dismissed.value = false;
});

onMounted(() => {
  systemStore.getConfiguration();
});

return (_ctx: any,_cache: any) => {
  return (_unref(systemStore).status.length > 0 && !dismissed.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dismissed.value = true)),
          class: "absolute top-0 py-2 font-normal cursor-pointer right-2 hover:text-primary"
        }, " Dismiss "),
        _createTextVNode(" " + _toDisplayString(_unref(systemStore).status), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})